import {
  TriggerServiceTitanImportRequest,
  TriggerServiceTitanImportResponse,
} from "./types";
import axiosInstance from "../axiosInstance";

export const triggerServiceTitanImport = async (
  companyUuid: string,
  request: TriggerServiceTitanImportRequest,
): Promise<TriggerServiceTitanImportResponse> => {
  const response = await axiosInstance.post<TriggerServiceTitanImportResponse>(
    `/api/private/companies/${companyUuid}/service-titan/import`,
    request,
  );
  return response.data;
};
